import type { ReactNode } from 'react';
import { formatDate } from '@/shared/format';
import { executionStatusLabel } from '@/modules/agreements/shared';
import { Field } from './execution-events';
import type { AgreementExecutionDetailResponse } from '@/api/schemas/agreements.types';

/** The subject's view of what was signed, and the hashes that bind it. */
export function ExecutionSummary(props: {
  execution: AgreementExecutionDetailResponse;
}): ReactNode {
  const execution = props.execution;
  return (
    <dl className="grid grid-cols-1 gap-3 text-sm sm:grid-cols-2">
      <Field label="Status" value={executionStatusLabel(execution.status)} />
      <Field label="Signing method" value={execution.signingMethod ?? '—'} />
      <Field label="Signer" value={execution.signerName ?? '—'} />
      <Field label="Title" value={execution.signerTitle ?? '—'} />
      <Field
        label="Completed"
        value={execution.completedAt ? formatDate(execution.completedAt) : '—'}
      />
      <Field label="Content hash" value={execution.contentHash} mono />
      <Field label="Signature hash" value={execution.signatureHash ?? '—'} mono />
      <Field label="PDF hash" value={execution.pdfHash ?? '—'} mono />
    </dl>
  );
}
